<template>
  <div class="flexible" ref="flexible">
    <transition name="fadeZoom">
      <alert v-if="alertData.isShow" v-model="alertData.isShow" @on-hide="_hideAlert" :info="alertData.info"></alert>
      <confirm v-if="confirmData.isShow" v-model="confirmData.isShow" @on-hide="_hideConfirm" @on-success="_successConfirm" :info="confirmData.info"></confirm>
    </transition>
    <toast v-if="toastData.isShow" v-model="toastData.isShow" @on-hide="hideToast" :info="toastData.info"></toast>
    <loading v-if="loadingData.isShow" v-model="loadingData.isShow" @on-hide="hideLoading" :info="loadingData.info"></loading>
    <actionSheet v-if="actionSheetData.isShow" v-model="actionSheetData.isShow" @on-success="_successActionSheet" :info="actionSheetData.info"></actionSheet>
  </div>
</template>
<script>
  import Vue from 'vue'

  import alert from "./alert.vue";
  import confirm from "./confirm.vue"
  import toast from "./toast.vue";
  import loading from "./loading.vue";
  import actionSheet from "./actionSheet.vue";

  export default {
    name: 'flexble',
    components: {
      alert,
      confirm,
      toast,
      loading,
      actionSheet
    },
    data: function () {
      return {
        alertData: {
          isShow: false,
          info: {
            title: "标题",
            content: "内容",
            buttonText: "确定"
          },
          success: function () {
          }
        },
        confirmData: {
          isShow: false,
          info: {
            title: "标题",
            content: "内容",
            confirmButtonText: "确定",
            cancelButtonText: "取消"
          },
          success: function () {
          }
        },
        toastData: {
          isShow: false,
          info: {
            content: "操作成功",
            type: "none",
            duration: 2000
          },
          success: function () {
          }
        },
        loadingData: {
          isShow: false,
          info: {
            content: "加载中..."
          },
        },
        actionSheetData: {
          isShow: false,
          info: {
            title: "",
          },
          success: function () {
          }
        },
      }
    },
    mounted() {
      Vue.prototype.flexible = this;
    },
    methods: {
      alert(data = {}) {
        this.alertData.isShow = true;
        this.alertData.info.title = data.title || "标题";
        this.alertData.info.content = data.content || "内容";
        this.alertData.info.buttonText = data.buttonText || "确定";
        if (data.success) {
          this.alertData.success = data.success;
        }
        else{
          this.alertData.success = function () {};
        }
      },
      _hideAlert() {
        this.alertData.isShow = false;
        this.alertData.success();
      },
      confirm(data = {}) {
        this.confirmData.isShow = true;
        this.confirmData.info.title = data.title || "标题";
        this.confirmData.info.content = data.content || "内容";
        this.confirmData.info.confirmButtonText = data.confirmButtonText || "确定";
        this.confirmData.info.cancelButtonText = data.cancelButtonText || "取消";
        if (data.success) {
          this.confirmData.success = data.success;
        }
        else{
          this.confirmData.success = function () {};
        }
      },
      _hideConfirm() {
        this.confirmData.isShow = false;
      },
      _successConfirm() {
        this._hideConfirm();
        this.confirmData.success({confirm:true});
      },
      showToast(data = {}) {
        this.toastData.isShow = true;
        this.toastData.info.content = data.content || "操作成功";
        this.toastData.info.type = data.type || "none";
        this.toastData.info.duration = data.duration || 2000;
        if (data.success) {
          this.toastData.success = data.success;
        }
        else{
          this.toastData.success = function () {};
        }
      },
      hideToast() {
        this.toastData.isShow = false;
        this.toastData.success();
      },
      showLoading(data = {}) {
        this.loadingData.isShow = true;
        this.loadingData.info.content = data.content || "加载中..";
      },
      hideLoading() {
        this.loadingData.isShow = false;
      },
      showActionSheet(data = {}) {
        this.actionSheetData.isShow = true;
        this.actionSheetData.info.title = data.title || "标题";
        this.actionSheetData.info.items = data.items || ["选项一", "选项二", "选项三"];
        this.actionSheetData.info.cancelButtonText = data.cancelButtonText || "取消";
        this.actionSheetData.info.destructiveBtnIndex = data.destructiveBtnIndex || -2;
        if (data.success) {
          this.actionSheetData.success = data.success;
        }
        else{
          this.actionSheetData.success = function () {};
        }
      },
      _successActionSheet(index) {
        this.actionSheetData.isShow = false;
        this.actionSheetData.success({index: index});
      }
    }
  }
</script>
<style lang="scss" type="text/scss">

</style>



// WEBPACK FOOTER //
// src/components/flexible-ui/index.vue